import LoginPage from "../../pages/auth/Login";
import { RouteLinks } from "../RouteLinks";

export const public_routes_group = [
  {
    path: RouteLinks.Login,
    element: LoginPage,
  },
];
